export const SHOP_FOLLOW_SET = 'SHOP_FOLLOW_SET';
export const SHOP_FOLLOW_SYNC = 'SHOP_FOLLOW_SYNC';
